import React, { useEffect, useState } from "react";
import "./SideMenu3.scss";
import { Link, useLocation } from "react-router-dom";
import { useStoreState } from "easy-peasy";

const SideMenu3 = () => {
  const location = useLocation();
  const [paths, setPaths] = useState([]);
  const urls = useStoreState((state) => state.path.paths);
  const careerUrls = useStoreState((state) => state.careerPath.paths);

  useEffect(() => {
    if (location.pathname.includes("extra")) {
      setPaths(urls);
    } else {
      setPaths(careerUrls);
    }
  }, [location]);

  return (
    <div className="SideListCont2">
      <ul className="list">
        {paths.map((el, index) => (
          <li key={index}>
            <Link
              className={
                location.pathname.includes(el.path) ? "activeLink" : ""
              }
              to={
                location.pathname.includes("extra")
                  ? "/extra/" + el.path
                  : "/career/" + el.path
              }
            >
              {el.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SideMenu3;
